<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <p class="title">RCI {{ i18n.prices[iso] }}</p>
        <!-- <b-tag type="is-success">{{ i18n.downloadInventory[iso] }}</b-tag> -->
        <div class="columns">
          <div class="column is-3">
            <b-button
              icon-left="dollar-sign"
              icon-pack="fas"
              type="is-success"
              size="is-small"
              @click="ModalCreatePrice = true"
              expanded
              >{{ i18n.createPrice[iso] }}</b-button
            >
          </div>
        </div>

        <!-- <p class="subtitle">Hero subtitle</p> -->
      </div>
    </section>
    <b-tabs v-model="tabFilters" position="is-centered">
      <b-tab-item>
        <template #header>
          <b-icon icon="filter" pack="fas" type="is-info"></b-icon>
          <b>{{ i18n.advancedSearch[iso] }}</b>
        </template>
        <div class="columns is-multiline">
          <div class="column is-3">
            <b-field label-position="on-border" label="ID">
              <b-input
                v-model="filters.Id"
                type="text"
                icon-right="times"
                icon-right-clickable
                expanded
              >
              </b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field label-position="on-border" :label="i18n.name[iso]">
              <b-input
                v-model="filters.Nombre"
                type="text"
                icon-right="times"
                icon-right-clickable
                expanded
              >
              </b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field label-position="on-border" :label="i18n.status[iso]">
              <b-select v-model="filters.Estado" expanded>
                <option :value="null">{{ i18n.all[iso] }}</option>
                <option :value="true">{{ i18n.active[iso] }}</option>
                <option :value="false">{{ i18n.blocked[iso] }}</option>
              </b-select>
            </b-field>
          </div>
          <!-- <div class="column is-8"></div> -->
          <div class="column is-1">
            <b-button
              icon-left="eraser"
              icon-pack="fas"
              type="is-danger is-light"
              @click="clearFilters"
              expanded
            ></b-button>
          </div>
          <div class="column is-2">
            <b-button
              icon-left="search"
              icon-pack="fas"
              type="is-info"
              @click="listRCIPrices()"
              expanded
              >{{ i18n.search[iso] }}</b-button
            >
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
    <b-table
      :data="prices"
      :paginated="isPaginated"
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :bordered="isBordered"
      :striped="true"
      :narrowed="isNarrowed"
      :hoverable="true"
      :loading="loadingTableList"
      :focusable="isFocusable"
      :mobile-cards="hasMobileCards"
      :detailed="false"
    >
      <b-table-column field="ID" label="ID" width="50" centered v-slot="props">
        {{ props.row.Id ? props.row.Id.split("-")[0] : "" }}
      </b-table-column>

      <b-table-column
        field="Name"
        :label="i18n.name[iso]"
        width="100"
        centered
        v-slot="props"
      >
        {{ props.row.Nombre || "" }}
      </b-table-column>

      <b-table-column
        field="Tipo"
        :label="i18n.type[iso]"
        width="100"
        centered
        v-slot="props"
      >
        {{ props.row.Tipo || "" }}
      </b-table-column>

      <b-table-column
        field="Monto"
        :label="i18n.amount[iso]"
        width="50"
        centered
        v-slot="props"
      >
        {{ props.row.Monto || "" }}
      </b-table-column>

      <b-table-column
        field="Activo"
        :label="i18n.status[iso]"
        width="100"
        centered
        v-slot="props"
      >
        <b-tag v-if="props.row.Activo" type="is-success">{{
          i18n.active[iso]
        }}</b-tag>
        <b-tag v-else type="is-danger">{{ i18n.inactive[iso] }}</b-tag>
      </b-table-column>

      <b-table-column label="Actions" v-slot="props" centered width="100">
        <b-tooltip type="is-info is-light">
          <b-button
            icon-left="eye"
            icon-pack="fas"
            size="is-small"
            type="is-info is-light"
            style="margin-right: 10px"
          ></b-button>
          <template v-slot:content>
            <b>{{ i18n.details[iso] }}</b></template
          >
        </b-tooltip>
      </b-table-column>

      <template #footer>
        <div class="columns">
          <div class="column is-11"></div>

          <div class="column is-1">
            <b-field :label="i18n.quantity[iso]">
              <b-select v-model="perPage" @input="savePerPage" expanded>
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <!-- <div class="has-text-right">Footer</div> -->
      </template>
    </b-table>

    <b-modal v-model="ModalCreatePrice" :width="700" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            {{ i18n.newLogicPrice[iso] }}
          </p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalCreatePrice = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="i18n.name[iso]">
                <b-input
                  v-model="newprice.Nombre"
                  type="text"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="newprice.Nombre = null"
                  expanded
                  :maxlength="30"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.type[iso]">
                <b-select expanded v-model="newprice.Tipo">
                  <option :value="'fixed'">{{ i18n.fixed[iso] }}</option>
                  <option :value="'percentage'">
                    {{ i18n.percentage[iso] }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.basePrice[iso]">
                <b-select expanded v-model="newprice.PrecioBase">
                  <option :value="'rci'">RCI</option>
                  <option :value="'formula'">Formula</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field
                :label="i18n.amount[iso]"
                :message="`${
                  newprice.Operacion === 'resta'
                    ? i18n.subtraction[iso]
                    : i18n.addition[iso]
                }`"
              >
                <p class="control">
                  <b-button
                    @click="newprice.Operacion = 'resta'"
                    :type="`is-danger ${
                      newprice.Operacion === 'resta' ? '' : 'is-light'
                    }`"
                    label="-"
                  />
                </p>
                <p class="control">
                  <b-button
                    @click="newprice.Operacion = 'suma'"
                    :type="`is-success ${
                      newprice.Operacion === 'suma' ? '' : 'is-light'
                    }`"
                    label="+"
                  />
                </p>
                <b-numberinput
                  expanded
                  :controls="false"
                  v-model="newprice.Monto"
                  :min="0"
                />
                <p class="control">
                  <span class="button is-static">{{
                    newprice.Tipo === "fixed" ? "$" : "%"
                  }}</span>
                </p>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="i18n.typeReference[iso]">
                <b-select expanded v-model="newprice.Referencia">
                  <option :value="'resorts'">Resorts</option>
                  <option :value="'clubs'">Clubs</option>
                  <option :value="'contracts'">Contracts</option>
                  <option :value="'members'">Members</option>
                  <option :value="'certificates'">Certificates</option>
                </b-select>
              </b-field>
            </div>

            <div class="column is-8">
              <b-field :label="i18n.reference[iso]">
                <b-button
                  expanded
                  :outlined="newprice.AllReferencias ? false : true"
                  @click="newprice.AllReferencias = true"
                  :type="`is-info ${newprice.AllReferencias ? '' : 'is-light'}`"
                  >{{ i18n.all[iso] }}
                </b-button>

                <b-button
                  :outlined="newprice.AllReferencias ? true : false"
                  expanded
                  v-if="newprice.Referencia === 'clubs'"
                  @click="
                    (ModalReferencias = true), (newprice.AllReferencias = false)
                  "
                  :type="`is-success ${
                    !newprice.AllReferencias ? '' : 'is-light'
                  }`"
                  >{{ i18n.totalSelected[iso] }}:
                  {{ newprice.ClubIds.length }}</b-button
                >
                <b-button
                  :outlined="newprice.AllReferencias ? true : false"
                  expanded
                  v-if="newprice.Referencia === 'resorts'"
                  :loading="loadingResorts"
                  @click="
                    (ModalReferencias = true), (newprice.AllReferencias = false)
                  "
                  :type="`is-success ${
                    !newprice.AllReferencias ? '' : 'is-light'
                  }`"
                  >{{ i18n.totalSelected[iso] }}:
                  {{ newprice.Resorts.length }}</b-button
                >
                <b-button
                  :outlined="newprice.AllReferencias ? true : false"
                  expanded
                  v-if="newprice.Referencia === 'contracts'"
                  @click="
                    (ModalReferencias = true), (newprice.AllReferencias = false)
                  "
                  :type="`is-success ${
                    !newprice.AllReferencias ? '' : 'is-light'
                  }`"
                  >{{ i18n.totalSelected[iso] }}:
                  {{ newprice.Contratos.length }}</b-button
                >
                <b-button
                  :outlined="newprice.AllReferencias ? true : false"
                  expanded
                  v-if="newprice.Referencia === 'members'"
                  @click="
                    (ModalReferencias = true), (newprice.AllReferencias = false)
                  "
                  :type="`is-success ${
                    !newprice.AllReferencias ? '' : 'is-light'
                  }`"
                  >{{ i18n.totalSelected[iso] }}:
                  {{ newprice.Socios.length }}</b-button
                >
                <b-button
                  :outlined="newprice.AllReferencias ? true : false"
                  expanded
                  v-if="newprice.Referencia === 'certificates'"
                  @click="
                    (ModalReferencias = true), (newprice.AllReferencias = false)
                  "
                  :type="`is-success ${
                    !newprice.AllReferencias ? '' : 'is-light'
                  }`"
                  >{{ i18n.totalSelected[iso] }}:
                  {{ newprice.Certificados.length }}</b-button
                >
              </b-field>
            </div>

            <!-- <div class="column is-12 has-text-centered" v-if="errorCert">
              <span style="color: #f14668; font-weight: bold">{{
                errorCert
              }}</span>
            </div> -->
          </div>
        </div>
        <footer class="card-footer">
          <!-- <a class="card-footer-item">
                  <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
                </a> -->
          <a class="card-footer-item" @click="createPrice">
            <span style="color: #48c78e; font-weight: bold; font-size: 130%">{{
              i18n.save[iso]
            }}</span>
            <b-icon
              pack="fas"
              :icon="loadingNewPrice ? 'sync-alt' : 'save'"
              type="is-success"
              :custom-class="loadingNewPrice ? 'fa-spin' : ''"
            ></b-icon>
          </a>
        </footer>
      </div>
    </b-modal>

    <b-modal
      v-model="ModalReferencias"
      :width="700"
      :can-cancel="['x', 'outside']"
    >
      <div class="card">
        <!-- <header class="card-header">
          <p class="card-header-title">
            {{ i18n.newLogicPrice[iso] }}
          </p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalCreatePrice = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header> -->
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-12" v-if="newprice.Referencia === 'resorts'">
              <b-field
                :label="i18n.filters[iso]"
                :type="`${rgxResorts !== '' ? 'is-info' : ''}`"
              >
                <b-input
                  v-model="rgxResorts"
                  @input="filterResorts"
                  :placeholder="i18n.reference__resorts__msg1[iso]"
                ></b-input>
              </b-field>
              <b-table
                :data="rgxResorts ? resortsFilters : resorts"
                :paginated="isPaginated"
                backend-pagination
                :total="rgxResorts ? resortsFilters.length : resorts.length"
                :per-page="perPage"
                @page-change="onPageChange"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :bordered="isBordered"
                :striped="true"
                :narrowed="isNarrowed"
                :hoverable="true"
                :loading="loadingResorts"
                :focusable="isFocusable"
                :mobile-cards="hasMobileCards"
                checkable
                :header-checkable="false"
                :checked-rows.sync="newprice.Resorts"
              >
                <b-table-column
                  field="ID"
                  label="ID"
                  width="50"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Id ? props.row.Id.split("-")[0] : "" }}
                </b-table-column>

                <b-table-column
                  field="Name"
                  :label="i18n.name[iso]"
                  width="300"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Name || "" }}
                </b-table-column>
              </b-table>
            </div>
            <div class="column is-12" v-if="newprice.Referencia === 'clubs'">
              <b-field
                :label="i18n.filters[iso]"
                :type="`${rgxClubs !== '' ? 'is-info' : ''}`"
              >
                <b-input
                  v-model="rgxClubs"
                  @input="filterClubs"
                  :placeholder="i18n.reference__clubs__msg1[iso]"
                ></b-input>
              </b-field>
              <b-table
                :data="rgxClubs ? clubsFilters : clubs"
                :paginated="isPaginated"
                backend-pagination
                :total="rgxClubs ? clubsFilters.length : clubs.length"
                :per-page="perPage"
                @page-change="onPageChange"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :bordered="isBordered"
                :striped="true"
                :narrowed="isNarrowed"
                :hoverable="true"
                :loading="loadingClubs"
                :focusable="isFocusable"
                :mobile-cards="hasMobileCards"
                checkable
                :header-checkable="false"
                :checked-rows.sync="newprice.ClubIds"
              >
                <b-table-column
                  field="ID"
                  label="ID"
                  width="50"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Id ? props.row.Id.split("-")[0] : "" }}
                </b-table-column>

                <b-table-column
                  field="Name"
                  :label="i18n.name[iso]"
                  width="300"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Nombre || "" }}
                </b-table-column>
              </b-table>
            </div>
            <div
              class="column is-12"
              v-if="newprice.Referencia === 'contracts'"
            >
              <b-field
                :label="i18n.filters[iso]"
                :type="`${rgxContracts !== '' ? 'is-info' : ''}`"
              >
                <b-input
                  v-model="rgxContracts"
                  @input="filterContracts"
                  :placeholder="i18n.reference__contracts__msg1[iso]"
                ></b-input>
              </b-field>
              <b-table
                :data="rgxContracts ? contractsFilters : contracts"
                :paginated="isPaginated"
                backend-pagination
                :total="
                  rgxContracts ? contractsFilters.length : contracts.length
                "
                :per-page="perPage"
                @page-change="onPageChange"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :bordered="isBordered"
                :striped="true"
                :narrowed="isNarrowed"
                :hoverable="true"
                :loading="loadingContracts"
                :focusable="isFocusable"
                :mobile-cards="hasMobileCards"
                checkable
                :header-checkable="false"
                :checked-rows.sync="newprice.Contratos"
              >
                <b-table-column
                  field="ID"
                  label="ID"
                  width="50"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Id }}
                </b-table-column>

                <b-table-column
                  field="Name"
                  :label="'LoginID'"
                  width="300"
                  centered
                  v-slot="props"
                >
                  {{ props.row.LoginID || "" }}
                </b-table-column>
              </b-table>
            </div>
            <div class="column is-12" v-if="newprice.Referencia === 'members'">
              <b-field
                :label="i18n.filters[iso]"
                :type="`${rgxMembers !== '' ? 'is-info' : ''}`"
              >
                <b-input
                  v-model="rgxMembers"
                  @input="filterMembers"
                  :placeholder="i18n.reference__members__msg1[iso]"
                ></b-input>
              </b-field>
              <b-table
                :data="rgxMembers ? membersFilters : members"
                :paginated="isPaginated"
                backend-pagination
                :total="rgxMembers ? membersFilters.length : members.length"
                :per-page="perPage"
                @page-change="onPageChange"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :bordered="isBordered"
                :striped="true"
                :narrowed="isNarrowed"
                :hoverable="true"
                :loading="loadingMembers"
                :focusable="isFocusable"
                :mobile-cards="hasMobileCards"
                checkable
                :header-checkable="false"
                :checked-rows.sync="newprice.Socios"
              >
                <b-table-column
                  field="ID"
                  :label="i18n.name[iso]"
                  width="150"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Nombre || "" }}
                  {{ props.row.ApellidoPaterno || "" }}
                </b-table-column>

                <b-table-column
                  field="Name"
                  :label="i18n.email[iso]"
                  width="300"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Email || "" }}
                </b-table-column>
              </b-table>
            </div>
            <div
              class="column is-12"
              v-if="newprice.Referencia === 'certificates'"
            >
              <b-field
                :label="i18n.filters[iso]"
                :type="`${rgxCertificates !== '' ? 'is-info' : ''}`"
              >
                <b-input
                  v-model="rgxCertificates"
                  @input="filterCertificates"
                  :placeholder="i18n.reference__certificates__msg1[iso]"
                ></b-input>
              </b-field>
              <b-table
                :data="rgxCertificates ? certificatesFilters : certificates"
                :paginated="isPaginated"
                backend-pagination
                :total="
                  rgxCertificates
                    ? certificatesFilters.length
                    : certificates.length
                "
                :per-page="perPage"
                @page-change="onPageChange"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :bordered="isBordered"
                :striped="true"
                :narrowed="isNarrowed"
                :hoverable="true"
                :loading="loadingCertificates"
                :focusable="isFocusable"
                :mobile-cards="hasMobileCards"
                checkable
                :header-checkable="false"
                :checked-rows.sync="newprice.Certificados"
              >
                <b-table-column
                  field="ID"
                  label="ID"
                  width="150"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Id || "" }}
                </b-table-column>

                <b-table-column
                  field="Name"
                  :label="i18n.email[iso]"
                  width="300"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Email || "" }}
                </b-table-column>
              </b-table>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="ModalReferencias = false">
            <span style="color: #f14668; font-weight: bold; font-size: 130%">{{
              i18n.close[iso]
            }}</span>
            <!-- <b-icon
              pack="fas"
              :icon="loadingNewPrice ? 'sync-alt' : 'save'"
              type="is-success"
              :custom-class="loadingNewPrice ? 'fa-spin' : ''"
            ></b-icon> -->
          </a>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import moment from "moment";
import i18n, { listMembers } from "../../utils/i18n";
// import ModalCreateUserSystem from "./ModalCreateUserSystem.vue";
// import ModalCreateRoleSystem from "./ModalCreateRoleSystem.vue";

const listCatalogues = ["CatIdiomas"];

export default {
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 10,
      hasInput: false,
      paginationOrder: "",
      inputPosition: "",
      inputDebounce: "",
      isBordered: false,
      isStriped: true,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,

      tabFilters: 0,
      filters: {
        Nombre: null,
        Id: null,
        Estado: null,
      },
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      clubesName: [],
      loadingExport: false,

      //Loading
      loadingTableList: false,
      loadingButton: false,

      //Data
      prices: [],
      total: 0,
      roles: [],
      listCatalogues,
      catalogues: {},

      //Modals
      ModalCreateUser: false,
      ModalCreateRole: false,

      //i18n
      i18n,
      iso: null,

      //Permissions
      permissions: "",

      ModalCreatePrice: false,
      ModalReferencias: false,
      newprice: {
        Nombre: null,
        Tipo: "fixed",
        Monto: 0,
        PrecioBase: "rci",
        Operacion: "suma",
        Referencia: "resorts",
        AllReferencias: true,
        ClubIds: [],
        Resorts: [],
        Contratos: [],
        Socios: [],
        Certificados: [],
      },
      loadingNewPrice: false,
      //Referencias
      loadingResorts: false,
      resorts: [],
      resortsFilters: [],
      rgxResorts: "",

      loadingClubs: false,
      clubs: [],
      clubsFilters: [],
      rgxClubs: "",

      loadingContracts: false,
      contracts: [],
      contractsFilters: [],
      rgxContracts: "",

      loadingMembers: false,
      members: [],
      membersFilters: [],
      rgxMembers: "",

      loadingCertificates: false,
      certificates: [],
      certificatesFilters: [],
      rgxCertificates: "",
    };
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    //Permissions
    this.permissions = localStorage.getItem("role");

    //PerPage
    // const perPageLocalStorage = localStorage.getItem("perPageReserves");
    // if (!perPageLocalStorage) this.savePerPage();
    // else this.perPage = perPageLocalStorage;

    //
    await this.listRCIPrices();
    this.listResorts();
    this.listClubs();
    this.listContracts();
    this.listMembers();
    this.listCertificates();
  },
  methods: {
    async listRCIPrices() {
      try {
        this.loadingTableList = true;
        let query = `?limit=${this.perPage}&page=${this.currentPage}`;
        const { data } = await axios.post(
          `${API_URL}/week/rci/list-price${query}`,
          {
            ...this.filters,
          }
        );
        this.prices = data?.rciPrices || [];
        this.total = (data?.rciPrices && data?.rciPrices.length) || 0;
        this.loadingTableList = false;
      } catch (err) {
        this.loadingTableList = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar usuarios",
          type: "is-danger",
        });
      }
    },
    savePerPage() {
      // localStorage.setItem("perPageReserves", this.perPage);
      // this.listRCIPrices();
    },
    onPageChange(page) {
      this.currentPage = page;
      // console.log("checkAdvancedSearch()", checkAdvancedSearch());
      // if (this.searchMembers && this.searchMembers !== "") {
      //   this.listAllMembers({
      //     rgx: this.searchMembers,
      //   });
      // } else if (this.checkAdvancedSearch(false)) {
      //   this.listAllMembers(this.advancedFilters);
      // } else {
      //   this.listRCIPrices();
      // }
    },
    parseDate(value) {
      moment.locale(this.iso);
      return value ? moment(value).format("MMMM D, YYYY") : "";
    },

    async clearFilters() {
      this.filters = {
        Nombre: null,
        Id: null,
        Estado: null,
      };
      await this.listRCIPrices();
    },

    // RESORTS
    async listResorts() {
      try {
        this.loadingResorts = true;
        let query = `?limit=${this.perPage}&page=${this.currentPage}&reference=resorts`;
        const { data } = await axios.post(
          `${API_URL}/week/data-by-reference${query}`,
          {
            // ...this.filters,
          }
        );
        this.resorts = data?.results || [];
        // this.totalResorts = (data?.resorts && data?.resorts.length) || 0;
        this.loadingResorts = false;
      } catch (err) {
        this.loadingResorts = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar resorts",
          type: "is-danger",
        });
      }
    },
    filterResorts() {
      const rgx = new RegExp(this.rgxResorts, "ig");
      this.resortsFilters = this.resorts.filter(
        (resort) => rgx.test(resort.Name) || rgx.test(resort.Id)
      );
    },
    // CLUBS
    async listClubs() {
      try {
        this.loadingClubs = true;
        let query = `?limit=${this.perPage}&page=${this.currentPage}&reference=clubs`;
        const { data } = await axios.post(
          `${API_URL}/week/data-by-reference${query}`,
          {
            // ...this.filters,
          }
        );
        this.clubs = data?.results || [];
        // this.totalResorts = (data?.resorts && data?.resorts.length) || 0;
        this.loadingClubs = false;
      } catch (err) {
        this.loadingClubs = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar clubs",
          type: "is-danger",
        });
      }
    },
    filterClubs() {
      const rgx = new RegExp(this.rgxClubs, "ig");
      this.clubsFilters = this.clubs.filter(
        (club) => rgx.test(club.Nombre) || rgx.test(club.Id)
      );
    },
    // CONTRACTS
    async listContracts() {
      try {
        this.loadingContracts = true;
        let query = `?limit=${this.perPage}&page=${this.currentPage}&reference=contracts`;
        const { data } = await axios.post(
          `${API_URL}/week/data-by-reference${query}`,
          {
            // ...this.filters,
          }
        );
        this.contracts = data?.results || [];
        // this.totalResorts = (data?.resorts && data?.resorts.length) || 0;
        this.loadingContracts = false;
      } catch (err) {
        this.loadingContracts = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar contracts",
          type: "is-danger",
        });
      }
    },
    filterContracts() {
      const rgx = new RegExp(this.rgxContracts, "ig");
      this.contractsFilters = this.contracts.filter(
        (contract) => rgx.test(contract.LoginID) || rgx.test(contract.Id)
      );
    },
    // MEMBERS
    async listMembers() {
      try {
        this.loadingMembers = true;
        let query = `?limit=${this.perPage}&page=${this.currentPage}&reference=members`;
        const { data } = await axios.post(
          `${API_URL}/week/data-by-reference${query}`,
          {
            // ...this.filters,
          }
        );
        this.members = data?.results || [];
        // this.totalResorts = (data?.resorts && data?.resorts.length) || 0;
        this.loadingMembers = false;
      } catch (err) {
        this.loadingMembers = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar members",
          type: "is-danger",
        });
      }
    },
    filterMembers() {
      const rgx = new RegExp(this.rgxMembers, "ig");
      this.membersFilters = this.members.filter((member) =>
        rgx.test(member.Email)
      );
    },
    // CERTIFICATES
    async listCertificates() {
      try {
        this.loadingCertificates = true;
        let query = `?limit=${this.perPage}&page=${this.currentPage}&reference=certificates`;
        const { data } = await axios.post(
          `${API_URL}/week/data-by-reference${query}`,
          {
            // ...this.filters,
          }
        );
        this.certificates = data?.results || [];
        // this.totalResorts = (data?.resorts && data?.resorts.length) || 0;
        this.loadingCertificates = false;
      } catch (err) {
        this.loadingCertificates = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar members",
          type: "is-danger",
        });
      }
    },
    filterCertificates() {
      const rgx = new RegExp(this.rgxCertificates, "ig");
      this.certificatesFilters = this.certificates.filter(
        (certificate) => rgx.test(certificate.Email) || rgx.test(certificate.Id)
      );
    },
    async createPrice() {
      try {
        this.loadingNewPrice = true;

        const payload = { ...this.newprice };
        delete payload.Socios;
        delete payload.Contratos;
        delete payload.ClubIds;
        delete payload.Resorts;
        delete payload.Certificados;

        if (
          this.newprice.Referencia === "resorts" &&
          !this.newprice.AllReferencias
        ) {
          payload.Datos = this.newprice.Resorts.map((resort) => resort.Id);
        }
        if (
          this.newprice.Referencia === "clubs" &&
          !this.newprice.AllReferencias
        ) {
          payload.Datos = this.newprice.ClubIds.map((club) => club.Id);
        }
        if (
          this.newprice.Referencia === "members" &&
          !this.newprice.AllReferencias
        ) {
          payload.Datos = this.newprice.Socios.map((socio) => socio.Email);
        }
        if (
          this.newprice.Referencia === "certificates" &&
          !this.newprice.AllReferencias
        ) {
          payload.Datos = this.newprice.Certificados.map(
            (certificate) => certificate.Id
          );
        }
        if (
          this.newprice.Referencia === "contracts" &&
          !this.newprice.AllReferencias
        ) {
          payload.Datos = this.newprice.Contratos.map(
            (contract) => contract.Id
          );
        }

        await axios.post(`${API_URL}/week/rci/create-price`, {
          ...payload,
        });

        await this.listRCIPrices();

        this.$buefy.toast.open({
          message: "Precio creado con éxito",
          type: "is-success",
        });

        this.ModalCreatePrice = false;
        (this.newprice = {
          Nombre: null,
          Tipo: "fixed",
          Monto: 0,
          PrecioBase: "rci",
          Operacion: "suma",
          Referencia: "resorts",
          AllReferencias: true,
          ClubIds: [],
          Resorts: [],
          Contratos: [],
          Socios: [],
          Certificados: [],
        }),
          (this.loadingNewPrice = false);
      } catch (err) {
        this.loadingNewPrice = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al crear precio",
          type: "is-danger",
        });
      }
    },
  },
};
</script>
